import React, { Fragment, useEffect } from "react";
import { Container, Row } from "react-bootstrap";
import "./Layout.css";
import "./Responsive.css";
import MenuHeader from "./components/Header";
import BannerPrincipal from "./components/BannerPrincipal";
import RazonUno from "./components/razones/RazonUno";
import RazonDos from "./components/razones/RazonDos";
import RazonTres from "./components/razones/RazonTres";
import RazonCuatro from "./components/razones/RazonCuanto";
import RazonCinco from "./components/razones/RazonCinco";
import RazonSeis from "./components/razones/RazonSeis";
import RazonSiete from "./components/razones/RazonSiete";
import RazonOcho from "./components/razones/RazonOcho";
import RazonNueve from "./components/razones/RazonNueve";
import Cta from "./components/Cta";
import Footer from "./components/razones/Footer";
import ReactGA from "react-ga";

function App() {
  useEffect(() => {
    ReactGA.initialize("G-TM5QC8CYB0");
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);
  return (
    <Fragment>
      <MenuHeader />
      <Container id="bloqueZero">
        <BannerPrincipal />
      </Container>
      <Container id="bloqueUno" className="marginBloques">
        <Row
          className="contentCards cardDark "
          id="RazonUno"
          data-aos="zoom-in"
          data-aos-duration="1000"
          data-aos-easing="ease-out"
        >
          <RazonUno />
        </Row>
      </Container>
      <Container id="bloqueDos" className="marginBloques">
        <Row
          className="contentCards cardLigth"
          id="razonDos"
          data-aos="zoom-in"
          data-aos-duration="1000"
          data-aos-easing="ease-out"
        >
          <RazonDos />
        </Row>
      </Container>
      <Container id="bloqueDosBis" className="marginBloques">
        <Row
          className="contentCards cardDark "
          id="razonTres"
          data-aos="zoom-in"
          data-aos-duration="1000"
          data-aos-easing="ease-out"
        >
          <RazonTres />
        </Row>
      </Container>
      <Container id="bloqueTres" className="marginBloques">
        <Row>
          <RazonCuatro />
          <RazonCinco />
        </Row>
      </Container>
      <Container id="bloqueCinco" className="marginBloques">
        <Row>
          <RazonSeis />
          <RazonSiete />
        </Row>
      </Container>
      <Container fluid id="bloqueSeis" className="marginBloques">
        <Container>
          <Row>
            <RazonOcho />
            <RazonNueve />
          </Row>
        </Container>
      </Container>
      <Container fluid id="contentCta">
        <Container id="cta">
          <Cta />
        </Container>
      </Container>
      <Container fluid id="contentFooter">
        <Container>
          <Footer />
        </Container>
      </Container>
    </Fragment>
  );
}

export default App;
